import React, { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/auth';

/**
 * Basic component that requires the user to be authenticated. If they are not
 * authenticated, they will be redirected to the login page.
 */
function RequireContractor({ children }: PropsWithChildren) {
  const { userContext, isReady } = useAuth();
  const location = useLocation();

  const user = userContext?.user;

  if (isReady && !userContext?.user) {
    // Redirect them to the "login" page "/", but save the current location they were
    // trying to go to when they were redirected.
    return <Navigate to="/sign_in" state={{ from: `${location.pathname}${location.search}` }} replace />;
  }

  if (user?.admin && !userContext?.currentContractor?.contractor) {
    window.location.assign(`${process.env.REACT_APP_MARKETPLACE_URL}/orders`);
    return;
  }

  return children;
}

export default RequireContractor;
